import { isValidJSON, showLoading } from "./modules/utilities.js";
import tabsInit from "./modules/tabs.js";

tabsInit();

var visitorData = {
	status: 200,
	results: {
		org: "Covanet",
		location: {
			country: "United States",
			city: "Glen Allen",
			state: "GA",
		},
		industries: [],
		isp: false,
		matchedSegments: [
			{
				code: 8021,
				name: "ABLEnow Virginia Visitors",
				lastMatchTimestamp: 1555512518008,
			},
			{
				code: 3585,
				name: "ABLE Location",
				lastMatchTimestamp: 1555512518008,
			},
		],
		abm: [],
		category: null,
		group: null,
	},
};

const currentUrl = new URL(window.location.href),
	host = currentUrl.origin,
	search = currentUrl.searchParams,
	ajaxUrl = host + "/ajax/event-list/?",
	listContainer = document.getElementById("js-event-list");

let params = {
	filterDisabled: false,
	inState: true,
	catId: "not any",
};

function initEvents() {
	listContainer.innerHTML = showLoading();

	if (search.get("filter") === "disable") {
		params.filterDisabled = true;
	}

	if (params.filterDisabled) {
		getEvents();
	} else {
		// callbackFunction(visitorData);
		rtp("get", "visitor", callbackFunction);
	}
}

function buildURL() {
	let urlQuery = Object.keys(params)
		.map(function (k) {
			return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
		})
		.join("&");

	return ajaxUrl + urlQuery;
}

function getEvents() {
	fetch(buildURL(), {
		method: "GET",
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => {
			return response.text();
		})
		.then((text) => {
			listContainer.innerHTML = text;
		})
		.catch((error) => {
			console.log("Error:", error);
		});
}

function callbackFunction(visitorData) {
	let stateNames = ["DE", "DC", "MD", "NC", "PA", "VA", "WV"],
		currentState = visitorData.results.location.state;

	if (!isValidJSON(visitorData) || visitorData.status !== 200) {
		console.log("ERROR: return data not vaild.");
		return false;
	}

	if (currentState == "") {
		return false;
	}

	if (!stateNames.includes(currentState)) {
		params.inState = false;

		getEvents();
	} else {
		getEvents();
	}
}

function removeSelectedBtnClass() {
	let selectedBtns = document.querySelectorAll(
		".js-event-category.button--selected"
	);

	for (let selectedBtn of selectedBtns) {
		selectedBtn.classList.remove("button--selected");
	}
}

// rtp("get", "visitor", callbackFunction);

// initEvents();

// const btns = document.getElementsByClassName('js-event-category');

// for (let i=0; i<btns.length; i++) {

//   btns[i].addEventListener('click', function(event) {
//     event.preventDefault();

//     removeSelectedBtnClass();

//     this.classList.add('button--selected');

//     params.catId = $(this).data("cat-id");

//     initEvents();

//   })
// }
